import { media } from '@helpers/media_templates';
import { THEME } from '@helpers/style_constants';
import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  html {
    margin: 0;
    height: 100%;
  }

  * {
    box-sizing: border-box;
  }

  body {
    color: ${THEME.color};
    margin: 0;
    position: relative;
    min-height: 100%;
    background: ${props => props.theme.backgroundColor};
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: primary-extended, sans-serif;
    text-align: left;
    font-weight: 400;
  }

  label, li, dt, dd, strong, em, span {
    font-family: primary-regular;
  }

  h1 {
    line-height: 40px;
    font-size: 36px;

    ${media.large`
      line-height: 1.0;
      font-size: 54px;
    `}
  }

  h2 {
    font-size: 20px;
    line-height: 1.36;
    font-family: primary-mono, monospace;
    letter-spacing: 0.24em;
    text-transform: uppercase;

    ${media.medium`
      font-size: 30px;
    `}
  }

  h3 {
    font-size: 20px;

    ${media.medium`
      font-size: 32px;
    `}
  }

  p {
    font-family: primary-regular, sans-serif;
    line-height: 1.42;
    font-size: 15px;

    ${media.medium`
      font-size: 18px;
    `}
  }

  a {
    font-family: primary-regular, sans-serif;
    color: ${props => props.theme.color};
  }

  small, address {
    font-family: primary-regular, sans-serif;
    font-style: normal;
    font-size: 14px;
    line-height: 20px;
  }

  button,
  input[type=submit] {
    cursor: pointer;
  }

  input:disabled,
  button:disabled {
    cursor: not-allowed;
  }

  td, th {
    border: 1px solid grey;
    padding: 1rem;
  }

  table {
    border-collapse: collapse;
  }
`;

export default GlobalStyle;
